__turbopack_context__.v({
  "tag": "style-module-scss-module__6RUytq__tag",
  "tags": "style-module-scss-module__6RUytq__tags",
});
